import { Entity, EntityRecord } from "@/orm/types";
import { Stack } from "@mantine/core";
import { DeleteButton } from "./DeleteButton";
import { Timestamps } from "./Timestamps";

export const SingletonSidebarActions = <T extends EntityRecord = EntityRecord>({
  entity,
  confirmationPath,
}: {
  entity: Entity<T>;
  confirmationPath: string;
}) => {
  return (
    <Stack>
      <Timestamps entity={entity} />
      <DeleteButton entity={entity} confirmationPath={confirmationPath} />
    </Stack>
  );
};
